import { computed } from 'vue'
import { defineStore } from 'pinia'
import { routes } from '@/router/routes'
import { useUserStore } from './user'

export const usePermissionStore = defineStore('permission', () => {
  const userStore = useUserStore()
  const menus = computed(() => {
    const layout = routes.find((route) => route.path === '/')
    return (layout?.children ?? []).filter((route) => {
      const required = route.meta?.permissions ?? []
      return !route.meta?.hidden && userStore.hasEveryPermission(required)
    })
  })
  return { menus }
})
